import React from 'react'
import Details from './Details'
import { Box, Typography } from '@mui/material'
import { HeadingText } from '../StyledComponents'

function Contact() {
  return (
    <>
        <Box id="contact" mt={5}>
          <Box data-aos="fade-up" data-aos-duration="2000">
            <HeadingText text="Contact Me" variant='h1' >
                Contact Me
            </HeadingText>
            <Typography my={5}
              sx={{
                textAlign:"center",
                padding:{xs:"0px 0px",sm:"0px 0px",md:"0px 200px"},
                color:"shade.light"
              }}>
                Drop a message using the form below, or reach me by phone from 9:00 am. to 8:00 pm., Monday to Friday. Can’t wait to hear from you!
              </Typography>
          </Box>
            <Details/>
        </Box>
    </>
  )
}

export default Contact